import React from "react";
import Img from "./basic/Img";

function Roll() {
    return (
        <div className="roll">
            <Img fileName={"roll"} />
        </div>
    );
}

export default Roll;
